import { render, staticRenderFns } from "./MasterCampaignsMenu.vue?vue&type=template&id=5593c334&"
import script from "./MasterCampaignsMenu.vue?vue&type=script&lang=js&"
export * from "./MasterCampaignsMenu.vue?vue&type=script&lang=js&"
import style0 from "./MasterCampaignsMenu.vue?vue&type=style&index=0&id=5593c334&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports